module.exports = __webpack_public_path__ + "img/deviceOffline.9d7a21d2.svg";